import Lightbox from 'react-spring-lightbox'

import { pxToRem } from '@/shared/styles/themes'
import { ButtonBase, styled } from '@mui/material'

import { PixieWorldIcon } from '../../Icon/PixieWorldIcon'

export const StyledLightBox = styled(Lightbox)`
  background-color: rgba(0, 0, 0, 0.75);
  z-index: ${props => props.theme.zIndex.modal} !important;

  .lightbox-image {
    cursor: url("/icons/magnifyingglass.svg"), pointer;
  }
`

export const StyledLightboxButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== '$isLeft',
}) <{ $isLeft?: boolean }>`
  border: 1px solid ${props => props.theme.palette.divider};
  margin: ${pxToRem(8)} ${pxToRem(8)} 0 ${pxToRem(8)};
  width: ${pxToRem(44)};
  min-width: ${pxToRem(44)};
  height: ${pxToRem(44)} !important;
  box-shadow: 0px 4px 15px rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.75);
  
  &:hover:enabled {
    background-color: white;
  }

  &:disabled {
    opacity: .3;
    cursor: auto;
    pointer-events: none;
  }
  
  &:active:enabled {
    opacity: .75;
  }

  .MuiButton-endIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: ${props => props.$isLeft ? props.theme.typography.pxToRem(-3) : 0};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    width: ${pxToRem(64)};
    height: ${pxToRem(64)} !important;
    min-width: ${pxToRem(64)};
    margin: ${pxToRem(28)} ${pxToRem(28)} 0 ${pxToRem(28)};
    background-color: white;
  }
`

export const StyledCheveronIcon = styled(PixieWorldIcon)`
  width: ${pxToRem(26)};
  height: ${pxToRem(26)};
`
